export default function HeaderCheckbox({ allCheckBox, allCheck }) {
  return (
    <label className="cont">
      <input className="checkbox" type="checkbox" onChange={allCheckBox} checked={allCheck} />
      <span className="checkbox-span"></span>
    </label>
  );
}
